import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useRef } from "react";
import bgArrowSvg from "../../assets/bg_arrow.svg";
import { SectionHeader } from "../SectionHeader";
import {
  backgroundArrowSx,
  cardsContainerSx,
  contentWrapperSx,
  scrollContainerSx,
  sectionContainerSx,
  stickyContainerSx,
  cardsWrapperSx,
  emblaViewportSx,
  emblaContainerSx,
  indicatorsContainerSx,
  getIndicatorSx,
} from "./OntologySection.sx";
import {
  cardsData,
  sectionTitle,
  sectionDescription,
} from "./OntologySection.config";
import { useOntologyAnimation } from "./useOntologyAnimation";
import { useOntologyCarousel } from "./useOntologyCarousel";
import { OntologyCard } from "./OntologyCard";

export const OntologySection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const arrowRef = useRef<HTMLImageElement>(null);

  useOntologyAnimation(sectionRef, arrowRef);
  const { emblaRef, activeCardId, setActiveCardId } = useOntologyCarousel();

  return (
    <Box
      component="section"
      ref={sectionRef}
      sx={scrollContainerSx}
      id="ontology-driven-ai"
    >
      <Box sx={stickyContainerSx}>
        {/* Background arrow */}
        <Box
          component="img"
          ref={arrowRef}
          src={bgArrowSvg}
          alt=""
          sx={backgroundArrowSx}
        />

        <Box sx={sectionContainerSx}>
          <Box sx={contentWrapperSx}>
            <SectionHeader
              title={sectionTitle}
              description={sectionDescription}
              variant="light"
            />

            <Box sx={cardsWrapperSx}>
              {/* Desktop: normal flex container */}
              <Box sx={cardsContainerSx}>
                {cardsData.map((card) => {
                  const isActive = card.id === activeCardId;
                  return (
                    <OntologyCard
                      key={card.id}
                      card={card}
                      isActive={isActive}
                      onClick={() => setActiveCardId(card.id)}
                    />
                  );
                })}
              </Box>

              {/* Mobile: Embla carousel */}
              <Box sx={emblaViewportSx} ref={emblaRef}>
                <Box sx={emblaContainerSx}>
                  {cardsData.map((card) => {
                    const isActive = card.id === activeCardId;
                    return (
                      <OntologyCard
                        key={card.id}
                        card={card}
                        isActive={isActive}
                        onClick={() => setActiveCardId(card.id)}
                      />
                    );
                  })}
                </Box>
              </Box>

              {/* Mobile carousel indicators */}
              <Stack direction="row" gap={1} sx={indicatorsContainerSx}>
                {cardsData.map((card) => (
                  <Box
                    key={card.id}
                    sx={getIndicatorSx(card.id === activeCardId)}
                  />
                ))}
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OntologySection;
